import { render, staticRenderFns } from "./ProductsTableAll.vue?vue&type=template&id=a7a8e3d8&"
import script from "./ProductsTableAll.vue?vue&type=script&lang=js&"
export * from "./ProductsTableAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports